import CategoryOutlinedIcon from "@mui/icons-material/CategoryOutlined";
import LocationCityOutlinedIcon from "@mui/icons-material/LocationCityOutlined";
import { FormattedMessage, useIntl } from "react-intl";
const useCustomerCornerItem = () => {
  const icons = {
    CategoryOutlinedIcon,
    LocationCityOutlinedIcon,
  };

  const servicceItems = {
    id: "group-customer-corner",
    title: (
      <FormattedMessage id="Knowledge Corner">
        {(text) => (
          <span style={{ fontSize: "14px", fontWeight: "normal" }}>{text}</span>
        )}
      </FormattedMessage>
    ),
    type: "group",
    icon: icons.CategoryOutlinedIcon,
    // url: "/articles-list",

    children: [
      {
        id: "articles-list",
        title: <FormattedMessage id="Articles List" />,
        type: "item",
        url: "/articles-list",
        icon: icons.CategoryOutlinedIcon,
        breadcrumbs: false,
      },
      {
        id: "articles-categories",
        title: <FormattedMessage id="Articles Categories" />,
        type: "item",
        url: "/articles-categories",
        icon: icons.LocationCityOutlinedIcon,
        breadcrumbs: false,
      },

      {
        id: "comments-list",
        title: <FormattedMessage id="Comments List" />,
        type: "item",
        url: "/comments-list",
        icon: icons.LocationCityOutlinedIcon,
        breadcrumbs: false,
      },
    ],
  };

  return servicceItems;
};

export default useCustomerCornerItem;
